import React from "react";
import cx from "classnames";
import styles from "../scss/DapRecommendedCover.module.scss";
import Icon from "../../common/components/Icon/Icon";
import { IRecommendedCover } from "../interfaces/IDigitalAdviceData";

interface IInterimRecommendCoverItem {
    title: string;
    recommendCover: IRecommendedCover;
}

const InterimRecommendCoverItem: React.FC<IInterimRecommendCoverItem> = (props) => {
    const { recommendCover, title } = props;

    return (
        <React.Fragment>
            <div className={styles["recommend-cover-section"]}>
                {title && (
                    <label
                        className={styles["recommend-cover-title"]}
                        id={`recommended-${title}`}>
                        {title}
                    </label>
                )}

                <div className={styles["recommend-cover-list"]}>
                    {!!(
                        recommendCover?.lifeCover &&
                        parseInt(recommendCover?.lifeCover) > 0
                    ) && (
                        <div
                            className={cx(
                                styles["recommended-covers"],
                                styles.lifeCover
                            )}>
                            <Icon className={styles.checkIcn} size="l" id="GreenTick" />
                            <div className={styles["recommended-covers--info"]}>
                                <div className={styles["recommended-covers--amount"]}>
                                    <label>Life Cover</label>
                                    <span>{recommendCover?.formattedLifeCover}</span>
                                </div>
                                <p className={styles["recommended-covers--description"]}>
                                    Have a lump sum paid out for your loved ones if you
                                    pass away.
                                </p>
                            </div>
                        </div>
                    )}
                    {!!(
                        recommendCover?.traumaCoverAmount &&
                        parseInt(recommendCover?.traumaCoverAmount) > 0
                    ) && (
                        <div
                            className={cx(
                                styles["recommended-covers"],
                                styles.traumaCover
                            )}>
                            <Icon className={styles.checkIcn} size="l" id="GreenTick" />
                            <div className={styles["recommended-covers--info"]}>
                                <div className={styles["recommended-covers--amount"]}>
                                    <label>Trauma Cover</label>
                                    <span>{recommendCover?.formattedTraumaCover}</span>
                                </div>
                                <p className={styles["recommended-covers--description"]}>
                                    Have a lump sum paid out if you are diagnosed with
                                    critical illness or injury.
                                </p>
                            </div>
                        </div>
                    )}
                    {!!recommendCover?.healthCoverExcessFormatted && (
                        <div
                            className={cx(
                                styles["recommended-covers"],
                                styles.healthCover
                            )}>
                            <Icon className={styles.checkIcn} size="l" id="GreenTick" />
                            <div className={styles["recommended-covers--info"]}>
                                <div className={styles["recommended-covers--amount"]}>
                                    <label>Health Cover</label>
                                    <span>
                                        {recommendCover?.healthCoverExcessFormatted}
                                    </span>
                                </div>
                                <p className={styles["recommended-covers--description"]}>
                                    Skip the public waiting list and get treatment faster.
                                </p>
                            </div>
                        </div>
                    )}
                    {!!(
                        recommendCover?.ipCoverAmountMonthly &&
                        parseInt(recommendCover?.ipCoverAmountMonthly) > 0
                    ) && (
                        <div
                            className={cx(
                                styles["recommended-covers"],
                                styles.incomeCover
                            )}>
                            <Icon className={styles.checkIcn} size="l" id="GreenTick" />
                            <div className={styles["recommended-covers--info"]}>
                                <div className={styles["recommended-covers--amount"]}>
                                    <label>Income Cover</label>
                                    <span>
                                        {recommendCover?.formattedIPCoverMonthly} per
                                        month
                                    </span>
                                </div>
                                <p className={styles["recommended-covers--description"]}>
                                    Protect your income if you are unable to work.
                                </p>
                            </div>
                        </div>
                    )}
                    {!!recommendCover?.tpdCover && (
                        <div
                            className={cx(
                                styles["recommended-covers"],
                                styles.mortgageCover
                            )}>
                            <Icon className={styles.checkIcn} size="l" id="GreenTick" />
                            <div className={styles["recommended-covers--info"]}>
                                <div className={styles["recommended-covers--amount"]}>
                                    <label>Mortgage Cover</label>
                                    <span>{recommendCover?.formattedTPDCover}</span>
                                </div>
                                <p className={styles["recommended-covers--description"]}>
                                    Protect your mortgage payments if you are unable to
                                    work.
                                </p>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </React.Fragment>
    );
};

export default InterimRecommendCoverItem;
